import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SMSListPage } from './list';
import { SMSViewPage } from './view';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';

export const SMSModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path=":id/*" element={<SMSViewPage />} />
        <Route path="/*" element={<SMSListPage />} />
      </Routes>
    </PageContentWrapper>
  );
};
